import { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getDocumentName } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { useMissionContext } from '../../../contexts/MissionContext/hooks/useMissionContext.hook';

import { MissionPage_OneMission_QueryDocument } from '../../Mission/hooks/useFindOneMissionQuery.hook';

import { MissionQuotationPage_OneQuotation_QueryDocument } from './useFindOneQuotationQuery.hook';

export const useQueryInvalidation = (quotationId: Id) => {
  const queryClient = useQueryClient();

  const { missionId } = useMissionContext();

  const queryKeyToInvalidate = useMemo(
    () => [
      getDocumentName(MissionQuotationPage_OneQuotation_QueryDocument),
      { id: quotationId },
    ],
    [quotationId],
  );

  const invalidateQueries = useCallback(() => {
    if (!quotationId) {
      return;
    }

    void queryClient.invalidateQueries({
      queryKey: queryKeyToInvalidate,
    });
  }, [queryClient, queryKeyToInvalidate, quotationId]);

  const invalidateMissionQueries = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: [
        getDocumentName(MissionPage_OneMission_QueryDocument),
        { id: missionId },
      ],
    });
  }, [queryClient, missionId]);

  return {
    invalidateQueries,
    queryKeyToInvalidate,
    invalidateMissionQueries,
  };
};
